import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { withStyles } from '@mui/styles';
import Divider from '@mui/material/Divider';
import logoMedium from '../../src/assets/logo-medium.png';
import { Home as HomeIcon, CreditCard as CreditCardIcon, MonetizationOn as MonetizationOnIcon, Receipt as ReceiptIcon, BarChart as BarChartIcon, ListAlt as ListAltIcon, InsertInvitation as InsertInvitationIcon, ShoppingCart as ShoppingCartIcon, Person as PersonIcon, ContactSupport as ContactSupportIcon, ExitToApp as ExitToAppIcon } from '@mui/icons-material';
import { colors } from '../theme/index.js';
import Text from '../components/Text.js';
class Sidebar extends Component {
  state = {
    selectedScreen: 'dashboard',
    options: [{
      title: "Dashboard",
      icon: /*#__PURE__*/React.createElement(HomeIcon, null),
      view: "dashboard",
      link: "/"
    }, {
      title: "Drug Card",
      icon: /*#__PURE__*/React.createElement(CreditCardIcon, null),
      view: "drug-card",
      link: "/drug-card"
    }, {
      title: "Spending Accounts",
      icon: /*#__PURE__*/React.createElement(MonetizationOnIcon, null),
      view: "spending-accounts",
      link: "/spending-accounts"
    }, {
      title: "Claims",
      icon: /*#__PURE__*/React.createElement(ReceiptIcon, null),
      view: "claims",
      link: "/claims"
    }, {
      title: "My Usage",
      icon: /*#__PURE__*/React.createElement(BarChartIcon, null),
      view: "usage",
      link: "/usage"
    }, {
      title: "Plan Coverage",
      icon: /*#__PURE__*/React.createElement(ListAltIcon, null),
      view: "coverage",
      link: "/coverage"
    }, {
      title: "Appointments",
      icon: /*#__PURE__*/React.createElement(InsertInvitationIcon, null),
      view: "appointments",
      link: "/appointments"
    }, {
      title: "Marketplace",
      icon: /*#__PURE__*/React.createElement(ShoppingCartIcon, null),
      view: "marketplace",
      link: "/marketplace"
    }],
    metaOptions: [{
      title: "My Account",
      icon: /*#__PURE__*/React.createElement(PersonIcon, null),
      view: "account",
      link: "/my-account"
    }, {
      title: "Support",
      icon: /*#__PURE__*/React.createElement(ContactSupportIcon, null),
      view: "support",
      link: "/support"
    }]
  };
  componentDidMount() {
    let selectedScreen = '';
    const href = window.location.href;
    if (href.includes('drug-card')) {
      selectedScreen = 'drug-card';
    } else if (href.includes('spending-accounts')) {
      selectedScreen = 'spending-accounts';
    } else if (href.includes('my-account')) {
      selectedScreen = 'account';
    } else if (href.includes('claims')) {
      selectedScreen = 'claims';
    } else if (href.includes('usage')) {
      selectedScreen = 'usage';
    } else if (href.includes('coverage')) {
      selectedScreen = 'coverage';
    } else if (href.includes('appointments')) {
      selectedScreen = 'appointments';
    } else if (href.includes('marketplace')) {
      selectedScreen = 'marketplace';
    } else if (href.includes('support')) {
      selectedScreen = 'support';
    } else {
      selectedScreen = 'dashboard';
    }
    this.setState({
      selectedScreen
    });
  }

  /*
   * Use with redux
   * _logout = () => {
   *     this.props.dispatch(logout());
   * };
   */

  render() {
    const {
      classes,
      id,
      testid
    } = this.props;
    const {
      options,
      metaOptions
    } = this.state;
    const email = this.props.user.email;
    const name = `${this.props.user.firstname} ${this.props.user.lastname}`;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.sidebar
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.sidebarHeader
    }, /*#__PURE__*/React.createElement(Link, {
      to: `/`,
      className: classes.titleLink
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Simply Benefits Logo",
      src: logoMedium,
      className: classes.logoSmall
    })), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      margin: "10px 0 0 0"
    }, name), /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, email)), /*#__PURE__*/React.createElement("div", {
      id: id || testid,
      className: classes.sidebarBody
    }, /*#__PURE__*/React.createElement(List, null, options && options.map(option => /*#__PURE__*/React.createElement(Link, {
      key: option.title,
      to: option.link,
      style: {
        textDecoration: 'none'
      },
      onClick: this.props.closeSideBar
    }, /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      className: `${classes.listItem} ${this.state.selectedScreen === option.view ? classes.selected : null}`
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, option.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: option.title
    })))), /*#__PURE__*/React.createElement(Divider, {
      variant: "middle",
      style: {
        margin: 20
      }
    }), metaOptions && metaOptions.map(metaOption => /*#__PURE__*/React.createElement(Link, {
      key: metaOption.title,
      to: metaOption.link,
      style: {
        textDecoration: 'none'
      },
      onClick: this.props.closeSideBar
    }, /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      className: `${classes.listItem} ${this.state.selectedScreen === metaOption.view ? classes.selected : null}`
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, metaOption.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: metaOption.title
    })))), /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      className: classes.listItem,
      onClick: this._logout
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(ExitToAppIcon, null)), /*#__PURE__*/React.createElement(ListItemText, {
      primary: "Logout"
    })))));
  }
}

/**
 *
 * @param {*} theme
 */
const styles = theme => ({
  sidebar: {
    backgroundColor: colors.surface,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%'
  },
  sidebarHeader: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.subHeaderGrey,
    flex: 0.2,
    minHeight: '200px'
  },
  sidebarBody: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.backgroundGrey,
    flex: 1,
    padding: '10px 30px'
  },
  listItem: {
    margin: '5px 0px',
    cursor: 'pointer'
  },
  logoSmall: {
    width: '60px'
  },
  selected: {
    backgroundColor: colors.backgroundGrey
  }
});
Sidebar.propTypes = {
  user: PropTypes.object
};
export default withStyles(styles)(Sidebar);

// When using the sidebar in an app with redux, add the following:
// /**
//  *
//  * @param {*} state
//  */
// const mapStateToProps = (state) => ({
//     user: state.user.meta
// });

// export default withStyles(styles)(connect(mapStateToProps)(Sidebar));